import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "modal_search_api",
  ref: "searchApiModalRef",
  tabindex: "-1",
  "aria-hidden": "true",
  "data-bs-backdrop": "static",
  "data-bs-keyboard": "false"
}
const _hoisted_2 = { class: "modal-dialog modal-dialog-centered w-400px" }
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = { class: "modal-header" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", null, "Search API", -1)
const _hoisted_6 = {
  class: "btn btn-sm btn-icon btn-active-color-primary",
  "data-bs-dismiss": "modal"
}
const _hoisted_7 = { class: "svg-icon svg-icon-1" }
const _hoisted_8 = { class: "modal-body py-lg-10 px-lg-10" }
const _hoisted_9 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "d-flex align-items-center fs-6 fw-bold mb-2" }, "Endpoint", -1)
const _hoisted_11 = { class: "d-flex flex-column mb-8 fv-row" }
const _hoisted_12 = {
  key: 0,
  class: "row"
}
const _hoisted_13 = { class: "d-flex align-items-center fs-6 fw-bold mb-2" }
const _hoisted_14 = ["onUpdate:modelValue"]
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Submit ", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Please wait... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_18 = [
  _hoisted_16,
  _hoisted_17
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_inline_svg = _resolveComponent("inline-svg")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("span", _hoisted_7, [
              _createVNode(_component_inline_svg, { src: "/media/icons/duotune/arrows/arr061.svg" })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createVNode(_component_el_cascader, {
              modelValue: _ctx.selectedConnEnd,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.selectedConnEnd) = $event)),
              options: _ctx.connEndOptions,
              props: { expandTrigger: 'hover' },
              onChange: _ctx.selConnEnd
            }, null, 8, ["modelValue", "options", "onChange"])
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_date_picker, {
              modelValue: _ctx.startEndDate,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.startEndDate) = $event)),
              type: "daterange",
              "unlink-panels": "",
              "range-separator": "To",
              "start-placeholder": "Start date",
              "end-placeholder": "End date",
              shortcuts: _ctx.shortcuts,
              "default-value": [new Date(), new Date()],
              "value-format": "YYYY-MM-DD"
            }, null, 8, ["modelValue", "shortcuts", "default-value"])
          ]),
          (_ctx.parameters)
            ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.parameters), (paramName, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-md-6 d-flex flex-column mb-8 fv-row",
                    key: index
                  }, [
                    _createElementVNode("label", _hoisted_13, _toDisplayString(paramName), 1),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-solid",
                      placeholder: "",
                      "onUpdate:modelValue": ($event: any) => ((_ctx.parameters[paramName]) = $event)
                    }, null, 8, _hoisted_14), [
                      [_vModelText, _ctx.parameters[paramName]]
                    ])
                  ]))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("button", {
              type: "submit",
              class: "btn btn-sm btn-primary",
              onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.formSubmit()), ["prevent"])),
              ref: "submitButton",
              "data-kt-menu-dismiss": "false"
            }, _hoisted_18, 512)
          ])
        ])
      ])
    ])
  ], 512))
}